<script lang="ts">
  import CmsImage from '$components/cms-image.svelte';
  import Info from '$components/info.svelte';
  import Masonry from '$components/masonry.svelte';
  import Testimonial from '$components/testimonial.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';
  import type { DetailedTestimonialStoryblok } from '$types/bloks';

  export let block: DetailedTestimonialStoryblok;

  const isMasonry = block.masonry;
</script>

<!-- Desktop -->
<section class="px-2 py-12 lg:px-8 lg:py-16 hidden lg:block">
  <div class="container isolate mx-auto" use:storyblokEditable={block}>
    <div class="flex justify-between">
      <div
        class={cn('w-4/12 flex flex-col', block.images?.length || 0 > 1 ? 'gap-[309px]' : 'gap-40')}
      >
        <Info block={block.info_block[0]} />
        <Testimonial block={block.testimonial[0]} class="sticky top-20  max-w-[448px]" />
      </div>
      {#if isMasonry}
        <Masonry {block} />
      {:else if block.images}
        <div class="w-7/12 flex flex-col gap-4 lg:items-end">
          {#each block.images as image}
            <CmsImage
              image={image.asset}
              class="relative z-10 max-h-[560px] rounded-md object-cover"
            />
          {/each}
        </div>
      {/if}
    </div>
  </div>
</section>
<!-- END Desktop -->

<!-- Mobile -->
<section class="py-12 block lg:hidden">
  <div class="flex flex-col gap-8">
    <div class="px-4">
      <Info block={block.info_block[0]} />
    </div>
    {#if isMasonry}
      <div class="px-2">
        <Masonry {block} />
      </div>
    {:else if block.images}
      <div
        class="flex gap-2 h-full w-full object-cover scroll snap-x snap-mandatory overflow-x-auto hide-scrollbar"
      >
        {#each block.images as image, i}
          <div
            class={cn(
              'select-none snap-center snap-always',
              block.images.length > 1 ? 'min-w-[90%]' : 'min-w-full'
            )}
          >
            <CmsImage
              image={image.asset}
              class={cn(
                'relative z-10 w-full rounded-md object-cover',
                i === 0 && 'pl-2',
                i === block.images.length - 1 && 'pr-2'
              )}
              options={{
                size: [1024, 0]
              }}
            />
          </div>
        {/each}
      </div>
    {/if}
    <div class="px-2">
      <Testimonial block={block.testimonial[0]} />
    </div>
  </div>
</section>
<!-- END Mobile -->
